import { CompetitorPricingPage } from '../../components/comparisons/CompetitorPricingPage';
import { COMPETITOR_PRICING_MAX_AGE_DAYS, getCompetitorPricing } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

/**
 * Wipster Pricing (2026): thin page over the shared pricing template. Numbers come from `competitor-pricing.ts`.
 */
const entry = getCompetitorPricing('wipster');

const WHEN_COMPETITOR_IS_BETTER = [
    "Your editors work in Premiere Pro, Final Cut Pro or After Effects and want a panel inside the app. Kreatli has no editing-software panels.",
    "You need multi-step approvals with an audit trail and one-click sign-off.",
    "Your team is larger than 10 and you want a listed per-user price. Wipster Team has no user limit; Kreatli above 10 members is Enterprise.",
    "You want an annual discount. Wipster Team is $19.95 per user billed annually; Kreatli is billed monthly only.",
];

export default function WipsterPricingPage() {
  return (
    <CompetitorPricingPage
      entry={entry}
      documentTitle="Wipster Pricing (2026): Plans, Limits & Real Cost"
      metaDescription="Wipster pricing explained: Light ($11.95) and Team ($25 per user, $19.95 annually), storage, no free plan, and what 3, 5, 10 and 15 users cost."
      h1="Wipster Pricing (2026)"
      heroText="Wipster’s Light and Team plans, monthly versus annual prices, and what a team of 3, 5, 10 or 15 pays each month."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="https://a.storyblok.com/f/287637539865613/2250x750/8d83a78aaf/best-video-review-platforms-for-creative-teams-in-2026.png"
      coverAlt="Wipster pricing breakdown"
      summary="Wipster Team is priced per user with no user limit, and it’s cheaper when billed annually. Light is one monthly price but doesn’t say how many users it covers, so team costs here are based on Team. There’s no free plan on the pricing page, only a trial."
      whenCompetitorIsBetter={WHEN_COMPETITOR_IS_BETTER}
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-pricing', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
